<template>
    <modal name="delete-modal" class="delete-modal"
           :width="600"
           :height="300"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div>
        <div class="keymodal_title">
            <div class="out_title">{{title}}</div>
        </div>
            <div class="box-delete-reason">
                <div class="text-delete-reason">삭제 사유</div>
                    <textarea class="input-delete-reason" v-model="reason" name="" id="" cols="30" rows="10" placeholder="내용을 입력하세요."></textarea>
            </div>
            <div class="box-btn mt10">
                <el-button  type="primary" @click="send">확인</el-button>
                <el-button  type="info" @click="backEvent" class="ml10">취소</el-button>
            </div>
            <button class="close_btn" @click="backEvent"></button>
        </div>
    </modal>
</template>
<script>
import util from '@/mixins/util';
import EventBus from "@/mixins/event-bus";
    export default {
        name: "DeleteModal",
        mixins: [],
        components: {
        },
        props: {},
        data() {
            return {
                title: '',
                reason:'',
                key:'',
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {

        },
        methods: {
            backEvent() {
                this.$modal.hide('delete-modal');
            },

            handlerBeforeOpen(event) {
                if(!util.isEmpty(event.params)){
                    if(event.params.hasOwnProperty('title') && !util.isEmpty(event.params.title)){
                        this.title = event.params.title
                    }   
                    if(event.params.hasOwnProperty('key') && !util.isEmpty(event.params.key)){
                        this.key = event.params.key
                    }              
                }
            },
            handlerBeforeClose() {
            },
            send(){
                EventBus.$emit("deleteReview",this.key,this.reason);
                this.title = '';
                this.reason = '';
                this.$modal.hide('delete-modal');
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>
